import { InjectionToken } from '@angular/core';
import { State } from './connection.store';
import { Connection } from './types/connection';

export const SOFTLINE_CONFIG_CONNECTION_DEFAULT_STATE =
  new InjectionToken<State>('SOFTLINE_CONFIG_CONNECTION_DEFAULT_STATE');
export const SOFTLINE_CONFIG_CONNECTION = new InjectionToken<Connection>(
  'SOFTLINE_CONFIG_CONNECTION'
);
